<section class="categories">
  <section class="categories__sidenavbar">
    <mat-list>
      <mat-list-item>
        <a (click)="showCategory('All')" mat-button>
          <span>All ({{total}})</span>
        </a>
        <mat-divider></mat-divider>
      </mat-list-item>
      <mat-list-item *ngFor="let item of categories | keyvalue">
        <a (click)="showCategory(item.key)" mat-button>
            <span>{{item.key}} ({{item.value}})</span>
        </a>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>
  </section>
  <section class="categories__content">
    <div class="categories__content__label">
      <mat-label>{{currentCategory}}</mat-label>
    </div>
    <div class="categories__content__cards">
      <ng-container *ngFor="let item of data">
        <mat-card *ngIf="item.category === currentCategory">
          <div class="categories__content__cards__header">
            <img mat-card-avatar src="https://s2.googleusercontent.com/s2/favicons?domain_url={{item.url}}" alt="icon">
            <mat-card-title>
              <a href="{{item.url}}"
               target="_blank"
               [ngClass]="{'longer': item.display_name.length > 50}"
               class="external-site">{{item.display_name}}</a>
            </mat-card-title>
          </div>
          <mat-card-content>
            <mat-card-subtitle>
              {{item.description}}
            </mat-card-subtitle>
          </mat-card-content>
       </mat-card>

       <mat-card *ngIf="!item.category && currentCategory === 'Other'">
          <div class="categories__content__cards__header">
          <img mat-card-avatar src="https://s2.googleusercontent.com/s2/favicons?domain_url={{item.url}}" alt="icon">
          <mat-card-title>
            <a href="{{item.url}}"
            [ngClass]="{'longer': item.display_name.length > 50}"
            target="_blank"
             class="external-site">{{item.display_name}}</a>
          </mat-card-title>
        </div>
        <mat-card-content>
          <mat-card-subtitle>
            {{item.description}}
          </mat-card-subtitle>
        </mat-card-content>
     </mat-card>

       <mat-card *ngIf="currentCategory === 'All'">
        <div class="categories__content__cards__header">
          <img mat-card-avatar
          src="https://s2.googleusercontent.com/s2/favicons?domain_url={{item.url}}"
          alt="icon">
          <mat-card-title>
            <a [ngClass]="{'longer': item.display_name.length > 50}"
              href="{{item.url}}"
              target="_blank"
              class="external-site">{{item.display_name}}</a>
          </mat-card-title>
        </div>
        <mat-card-content>
          <mat-card-subtitle>
            {{item.description}}
          </mat-card-subtitle>
        </mat-card-content>
     </mat-card>
      </ng-container>
    </div>
  </section>
</section>
